import get from 'lodash/get';
import React from 'react'
import { useTranslation } from 'react-i18next';
import HistoryBlock, { processHistory } from './HistoryBlock';

const HistorySptConsent = ({device}) => {
  const { t } = useTranslation();

  return (
    <HistoryBlock
      title={t("devices.SptVendorConsentHistory")}
      data={
        processHistory("spt_consent")(get(device, 'history.spt_consent'))}
      cloumnTitle="Spt consent"
      cloumnAccessor={"spt_consent"}
    />
   );
}

export default HistorySptConsent;